import React, { forwardRef } from "react";
import { ICONS } from "./icons";
import "./rc-ui.scss";

const SIZES = ["xs", "sm", "md", "lg", "xl"];
const warnedNames = new Set();

/**
 * Shared Lucide icon. Add supported names to icons.js rather than importing
 * from lucide-react at call sites.
 */
const Icon = forwardRef(({
  name,
  size = "md",
  label,
  strokeWidth = 1.75,
  className = "",
  ...rest
}, ref) => {
  const LucideIcon = ICONS[name];

  if (!LucideIcon) {
    if (!warnedNames.has(name)) {
      warnedNames.add(name);
      console.warn(`Unknown RC UI icon: ${name}`);
    }
    return null;
  }

  const sizeClass = SIZES.includes(size) ? size : "md";
  const classes = ["rc-ui-icon", `rc-ui-icon--${sizeClass}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <LucideIcon
      ref={ref}
      className={classes}
      color="currentColor"
      strokeWidth={strokeWidth}
      role={label ? "img" : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : "true"}
      {...rest}
    />
  );
});

Icon.displayName = "Icon";

export default Icon;
